import _ from "underscore";
export default function joinObjects(objectList1, objectList2) {
  return _.zip(objectList1, objectList2).map(([obj1, obj2]) => ({
    ...obj1,
    ...obj2,
  }));
}
